import { useHistory, useLocation, useParams, useRouteMatch } from './Router';
export var useNavigatorHistory = useHistory;
export var useNavigatorLocation = useLocation;
export var useNavigatorParams = useParams;
export var useNavigatorRouteMatch = useRouteMatch;